import React, {useCallback, useState} from 'react';
import styles from './DetailsModal.module.scss'
import NavToggle from "components/icons/navToggle/NavToggle";
import {buttonClick} from "utils/Helpers";
import MouseAround from "components/icons/mouseAround/MouseAround";

const DetailsModal = (props) => {

    const [modalActive, setModalActive] = useState(true);

    const focus = useCallback((node)=>{
            if(node) setTimeout(()=>node.focus(),100)
    }, [])

    return !modalActive ? <></> : (
        <div className={styles.details}>

            <p ref={(node)=>focus(node)}  className={styles.accessible} tabIndex={-1}>The Surface Originals image gallery contains many images and posts to explore. To exit the gallery and return to the main site press the escape key at any time</p>

            {props.finalistModal ? (
                <>
                    <h2>Originals Finalists</h2>
                    <p>Congratulations to our 20 Original by design contest finalists! Check back in October to see who the grand prize winners are!</p>
                </>
            ) : (
                <>
                    <h2>Surface Originals</h2>
                    <p>It started with thousands of entries that were narrowed down to 20 finalists. Now four winners have been selected. Congratulations to our winners and everyone who participated in the Original&nbsp;by&nbsp;design&nbsp;contest.</p>
                </>
            )}

            <div className={styles.mouseAround}>
                <MouseAround/>
            </div>

            <p className={styles.rules}>
                {!props.finalistModal && (
                    <a href={'/contest.pdf'} target={'_blank'} rel={'noreferrer'}>Official rules</a>
                )}
            </p>

            {props.error && <p className={styles.error}>{props.error}</p>}

            <div tabIndex={0} role={'button'} aria-label={'Close introduction modal'} onKeyDown={buttonClick} className={styles.close} onClick={() => setModalActive(false)}>
                <NavToggle menuOpen={true} closeOnly={true} color={'#fff'}/>
            </div>
        </div>
    )
};

export default DetailsModal
